export default __webpack_public_path__ + "static/media/hamburger_music_off_button.2b522fcd.png";